module.exports = "<y-datepicker params=\"numbericValue:numbericValue,minDate:minDate,maxDate:maxDate,placeholder:placeholder,data: data, isTimer:true,position: position,disabled:disabled,fieldid: fieldid\">\n</y-datepicker>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/datetimepicker/index.html
// module id = 367
// module chunks = 0